import { AppointmentAdvancePaymentRefund } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';
import { AppointmentDetails } from '@dreryk/egabinet-appointment-frontend-api';

import { Notification, NotificationSize, NotificationType, StyledFlex } from '@dreryk/react-components';

import { appointmentAdvancePaymentAutomaticRefundVisitor } from '~libs.shared.appointment-advance-payment';
import {
   AppointmentBeginDateTextView,
   AppointmentPatientTextView,
   AppointmentPractitionerTextView,
} from '~libs.desktop.shared.appointment';

import { AdvancePaymentDateTextView } from '../components/AdvancePaymentDateTextView';
import { AdvancePaymentMethodTypeTextView } from '../components/AdvancePaymentMethodTypeTextView';
import { AdvancePaymentAmountTextView } from '../components/AdvancePaymentAmountTextView';
import { translationKeys } from '../translations';
import { AdvancePaymentRefundMethodTypeTextView } from '../components/AdvancePaymentRefundMethodTypeTextView';
import { AdvancePaymentRefundAmountTextView } from '../components/AdvancePaymentRefundAmountTextView';

type AppointmentAdvancePaymentUnpaidViewProps = Readonly<{
   automaticRefundEnabled: boolean;
   appointmentAdvancePaymentRefund: AppointmentAdvancePaymentRefund | null;
   appointmentDetails: AppointmentDetails;
}>;

export const AppointmentAdvancePaymentUnpaidView = (props: AppointmentAdvancePaymentUnpaidViewProps): JSX.Element => {
   return (
      <>
         <StyledFlex gap={20}>
            <AppointmentBeginDateTextView beginDate={props.appointmentDetails.beginDate} />
            <AppointmentPatientTextView patient={props.appointmentDetails.patient} />
         </StyledFlex>

         <AppointmentPractitionerTextView practitioner={props.appointmentDetails.practitioner} />

         <AdvancePaymentDateTextView paymentDate={null} />

         <StyledFlex direction={'column'} gap={20}>
            <StyledFlex gap={20}>
               <StyledFlex gap={20} direction={'column'}>
                  <AdvancePaymentMethodTypeTextView paymentMethodType={null} />
                  <AdvancePaymentAmountTextView amount={null} />
               </StyledFlex>

               {appointmentAdvancePaymentAutomaticRefundVisitor(
                  {
                     automaticRefundEnabled: props.automaticRefundEnabled,
                     appointmentAdvancePaymentRefund: props.appointmentAdvancePaymentRefund,
                  },
                  {
                     visitWithAutomaticRefund: () => (
                        <StyledFlex gap={20} direction={'column'}>
                           <AdvancePaymentRefundMethodTypeTextView refundMethodType={null} />
                           <AdvancePaymentRefundAmountTextView refundAmount={null} expirationDate={null} />
                        </StyledFlex>
                     ),
                  }
               )}
            </StyledFlex>

            <Notification
               testId={'advancePaymentNotProcessed'}
               type={NotificationType.WARNING}
               size={NotificationSize.SMALLER}
               label={appointmentAdvancePaymentAutomaticRefundVisitor(
                  {
                     automaticRefundEnabled: props.automaticRefundEnabled,
                     appointmentAdvancePaymentRefund: props.appointmentAdvancePaymentRefund,
                  },
                  {
                     visitWithAutomaticRefund: () => translationKeys.advancePaymentNotProcessedNoAutomaticRefund,
                     visitWithoutAutomaticRefund: () => translationKeys.advancePaymentNotProcessed,
                  }
               )}
            />
         </StyledFlex>
      </>
   );
};
